__turbopack_context__.v({
  "card": "PerspectiveCard-module-scss-module__KUVVgG__card",
  "category": "PerspectiveCard-module-scss-module__KUVVgG__category",
  "image": "PerspectiveCard-module-scss-module__KUVVgG__image",
  "link": "PerspectiveCard-module-scss-module__KUVVgG__link",
  "meta": "PerspectiveCard-module-scss-module__KUVVgG__meta",
  "stack-module-0": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-0",
  "stack-module-1": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-1",
  "stack-module-10": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-10",
  "stack-module-11": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-11",
  "stack-module-12": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-12",
  "stack-module-13": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-13",
  "stack-module-14": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-14",
  "stack-module-15": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-15",
  "stack-module-16": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-16",
  "stack-module-17": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-17",
  "stack-module-18": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-18",
  "stack-module-19": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-19",
  "stack-module-2": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-2",
  "stack-module-20": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-20",
  "stack-module-3": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-3",
  "stack-module-4": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-4",
  "stack-module-5": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-5",
  "stack-module-6": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-6",
  "stack-module-7": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-7",
  "stack-module-8": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-8",
  "stack-module-9": "PerspectiveCard-module-scss-module__KUVVgG__stack-module-9",
  "title": "PerspectiveCard-module-scss-module__KUVVgG__title",
  "z-base": "PerspectiveCard-module-scss-module__KUVVgG__z-base",
  "z-content": "PerspectiveCard-module-scss-module__KUVVgG__z-content",
  "z-footer": "PerspectiveCard-module-scss-module__KUVVgG__z-footer",
  "z-header": "PerspectiveCard-module-scss-module__KUVVgG__z-header",
  "z-hero": "PerspectiveCard-module-scss-module__KUVVgG__z-hero",
  "z-logo": "PerspectiveCard-module-scss-module__KUVVgG__z-logo",
  "z-logo-effect": "PerspectiveCard-module-scss-module__KUVVgG__z-logo-effect",
  "z-navigation": "PerspectiveCard-module-scss-module__KUVVgG__z-navigation",
  "z-sub": "PerspectiveCard-module-scss-module__KUVVgG__z-sub",
});
